import {
    Box,
    Checkbox,
    CircularProgress,
    Paper,
    Switch,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TablePagination,
    TableRow, TableSortLabel,
} from "@mui/material";
import {translate} from "../../translate/translate";
import * as React from "react";
import {useEffect} from "react";
import TableMenuComponent from "../table-menu/table-menu.component";
import {useAuth} from "../../contexts/auth-context";
import {Value} from "./value-row-column.component";
import Divider from "@mui/material/Divider";
import {Choice} from "../../dto/choice";
import {ErrorComponent} from "../error/error.component";
import {DateTimeFormat} from "../date/date-timeFormat";
import {formatNumber} from "../../utils/format-number";

const TablePaginationComponent = (props: any) => {
    const {
        displayedColumnsShow,
        displayedColumns,
        orderByColumns,
        orderByFn,
        orderBy,
        orderDirection,
        customColumns,
        customCellRender,
        customHead,
        customHeadRender,
        displayedTranslate,
        handleSwitch,
        columnStyles,
        fixedColumns,
        field,
        fieldList,
        service,
        dateColumns,
        numberColumns,
        currencyColumns,
        showActions,
        handleDuplicate,
        handleRowSelect,
        selectedRows,
        selectedField,
        menuLayout = false,
        rowsPerPageOptions=[5, 10, 25, 50],
        goToDetail,
        loading,
        errorRow,
        secondaryLayout = false,
        downloadFn,
        integerColumns,
        hideHeader = false,
        groupByColumn,
        customMenuItems,
        highlightedColumns,
        highlightedColor,
        highlightedColumnsColor,
        isNpiTemplate,
    } = props;
    const {user} = useAuth();

    const [choices, setChoices] = React.useState<Choice[]>([]);
    const [choicesList, setChoicesList] = React.useState<any>({});

    const getChoices = () => {
        if (field) {
            service.getChoices(field).then((response: any) => {
                setChoices(response?.map((item: any) => item));
            }).catch((error: any) => {
                ErrorComponent(error);
            });
        }
    };

    const getChoicesList = () => {
        if (fieldList) {
            fieldList.forEach((field: string) => {
                service.getChoices(field).then((response: any) => {
                    setChoicesList((value: any) => ({
                        ...value,
                        [field]: response?.map((item: any) => item)
                    }));
                }).catch((error: any) => {
                    ErrorComponent(error);
                });
            });
        }
    };

    useEffect(() => {
        getChoices();
        getChoicesList();
    }, []);

    const translateTitleColumn = (column: string, index: number): string => {
        return displayedColumnsShow === undefined || displayedColumnsShow.length !== displayedColumns.length
            ? translate.t(column)
            : translate.t(displayedColumnsShow[index]);
    };

    const translateRowColumn = (column: string, index: number, row: any): string => {
        const value = String(Value(row, column));
        return (
            (value === "" || value === undefined || value === null)
                ? "-"
                : (
                    displayedTranslate !== undefined && displayedTranslate.length > 0 &&
                    displayedTranslate.find((choice: any) => choice == column) !== undefined
                )
                    ? translate.t(value)
                    : value
        );
    };

    const changeSwitch = (row: any): boolean => {
        return "email" in row && "username" in row && row.id === user.id;
    };

    const dateFormat = (column: string, row: any) => {
        const date_str = String(Value(row, column))
            .replace(/^(\d{4})-(\d{2})-(\d{2})$/,
                (match, year, month, day) => `${day}/${month}/${year}`);

        const time_str = String(Value(row, column))
            .match(/(\d{2}):(\d{2})/);

        if (time_str != null){
            return DateTimeFormat(Value(row, column));
        }

        return date_str;
    };

    const isSwitch = (column: string): boolean => {
        return column === "is_superuser" || column === "is_active" || column === "active" || column === "default" || column === "is_top_bottom";
    };

    const isDate = (column: string): boolean => {
        return dateColumns === undefined
            ? false
            : dateColumns.includes(column);
    };

    const isNumber = (column: string): boolean => {
        return numberColumns === undefined
            ? false
            : numberColumns.includes(column);
    }

    const renderCell = (column: string, index: number, row: any) => {
        if (customColumns && customColumns.includes(column.toLocaleLowerCase())) {
            return customCellRender(column, index, row);
        }
        if (column === field) {
            const choice = choices.find((choice: any) => choice.value === row[column]);
            return choice?.display_name;
        }
        if (fieldList && fieldList.includes(column)) {
            const choice = choicesList[column].find((choice: any) => choice.value === row[column]);
            return choice?.display_name;
        }
        return column === "isRowSelectable" ? (
            selectedField ? (
                <Checkbox
                    checked={selectedRows.some((selectedRow: any) => selectedRow[selectedField] === row[selectedField])}
                    onChange={() => handleRowSelect(row)}
                />
            ) : (
                <Checkbox
                    checked={selectedRows.some((selectedRow: any) => selectedRow.id === row.id)}
                    onChange={() => handleRowSelect(row)}
                />
            )
        ) : isSwitch(column) ? (
            <Switch
                color="secondary"
                checked={Value(row, column)}
                onChange={() =>
                    !changeSwitch(row) && handleSwitch(row, column)
                }
                disabled={row.id === user?.id && row.username === user?.username}
            />
        ) : (
            isDate(column) ? dateFormat(column, row)
                : isNumber(column) ? formatNumber(Value(row, column), currencyColumns?.includes(column),integerColumns?.includes(column) ? 0 : 2)
                    : (
                        column === "color" ?
                            <Box
                                width="20px"
                                height="20px"
                                borderRadius="50%"
                                bgcolor={row[column]}
                            ></Box>
                            : translateRowColumn(column, index, row)
                    )
        );
    };

    const showPaginated = (from: number, to: number, count: number) => {
        return `${from} - ${to} ${translate.t("of")} ${count}`;
    };

    const primaryHeadStyle = {
        lineHeighteight: "48px",
        padding: "0 14px",
        fontSize: "14px",
        fontWeight: "600",
        color: "rgba(0, 0, 0, 0.87) !important",
        backgroundColor: "#EEEEEE",
        paddingTop: "15px",
        paddingBottom: "15px",
    }

    const secondaryHeadStyle = {
        lineHeighteight: "38px !important",
        padding: "5px 14px",
        fontSize: "14px",
        fontWeight: "600",
        color: "rgba(0, 0, 0, 0.87) !important",
        backgroundColor: "#ededed",
    }

    const alignCell = (column: string) => {
        return numberColumns?.includes(column) ? "right" : "left";
    }

    const groupByColor = (array: string[]) => {
        let lastColor = "#f5f5f5";
        const alternateColor = "#eaeaea";
        let lastValue: any = null;

        return array.map((item: string) => {
            if (item !== lastValue) {
                lastColor = lastColor === "#f5f5f5" ? alternateColor : "#f5f5f5";
                lastValue = item;
            }

            return {
                name: item,
                color: lastColor,
            };
        });
    };

    const groupByColumnStyle = (row: any) => {
        const array = props.state.map((item: any) => item[groupByColumn]);
        const grouped = groupByColor(array);

        return grouped.find((item: any) => item.name === row[groupByColumn])?.color;
    };

    return (
        <Box sx={{width: "100%"}}>
            <Paper sx={{boxShadow: secondaryLayout ? "none" : ""}}>
                <TableContainer>
                    <Table size="small">
                        {!hideHeader && (<TableHead>
                            <TableRow>
                                {displayedColumns
                                    .filter((obj: string) => obj !== "action")
                                    .map((column: string, index: any) => (
                                        <TableCell
                                            key={column}
                                            sx={{
                                                ...(secondaryLayout ? secondaryHeadStyle : primaryHeadStyle),
                                                zIndex: 3,
                                                width:
                                                    columnStyles && columnStyles[index + 1]
                                                        ? columnStyles[index + 1]
                                                        : undefined,
                                                minWidth:
                                                    fixedColumns?.length ? columnStyles && columnStyles[index + 1]
                                                        ? columnStyles[index + 1]
                                                        : undefined : undefined,
                                                position:
                                                    fixedColumns?.length && fixedColumns.includes(column)
                                                        ? "sticky"
                                                        : undefined,
                                                left:
                                                    fixedColumns?.length && fixedColumns.includes(column)
                                                        ? index === 0 ? 0 : columnStyles && columnStyles[index]
                                                        : undefined,
                                                textAlign: alignCell(column),
                                            }}
                                            sortDirection={orderBy?.replace("-", "") === column ? orderDirection : false}
                                        >
                                            {orderByColumns && orderByColumns.includes(column) ? (
                                                <TableSortLabel
                                                    color="rgba(0, 0, 0, 0.87)"
                                                    active={!!orderDirection && orderBy?.replace("-", "") === column}
                                                    direction={orderBy === column ? orderDirection : 'desc'}
                                                    onClick={(event) => {
                                                        event.stopPropagation();
                                                        event.preventDefault();
                                                        orderByFn(column, orderDirection)
                                                    }}
                                                    hideSortIcon={false}
                                                    sx={
                                                        {
                                                            color: 'rgba(0, 0, 0, 0.87)',
                                                            '& .MuiTableSortLabel-icon': {
                                                                color: 'rgba(0, 0, 0, 0.87)',
                                                            },
                                                        }
                                                    }
                                                >
                                                    {translateTitleColumn(column, index)}
                                                </TableSortLabel>
                                            ) : (
                                                <>{customHead?.includes(column) ? customHeadRender(column, index, props.state) : translateTitleColumn(column, index)}</>
                                            )}
                                        </TableCell>
                                    ))}
                                {displayedColumns.includes("action") && (
                                    <TableCell
                                        align="center"
                                        sx={{
                                            ...(secondaryLayout ? secondaryHeadStyle : primaryHeadStyle),
                                        }}>
                                        {translate.t("actions")}
                                    </TableCell>
                                )}
                            </TableRow>
                        </TableHead>)}
                        <TableBody sx={{cursor: "pointer"}}>
                            {props.state && props.state.length > 0 ? (
                                props.state.map((row: any) => (
                                    <TableRow
                                        key={row.id}
                                        sx={{"&:last-child td, &:last-child th": {border: 0}}}
                                        onDoubleClick={() => {
                                            if (props.handleDoubleClick) {
                                                props.handleDoubleClick(row);
                                            }
                                        }}
                                    >
                                        {displayedColumns
                                            .filter((obj: string) => obj !== "action")
                                            .map((column: string, index: any) => (
                                                <TableCell key={column}
                                                           sx={{
                                                               wordBreak: "break-word",
                                                               fontSize: "14px",
                                                               position:
                                                                   fixedColumns?.length && fixedColumns.includes(column)
                                                                       ? "sticky"
                                                                       : undefined,
                                                               left:
                                                                   fixedColumns?.length && fixedColumns.includes(column)
                                                                       ? index === 0 ? 0 : columnStyles && columnStyles[index]
                                                                       : undefined,
                                                               backgroundColor:
                                                                   fixedColumns?.length && fixedColumns.includes(column)
                                                                       ? "#fafafa"
                                                                       : !!errorRow && errorRow(row)
                                                                           ? "#FFEBEE"
                                                                           : !!groupByColumn
                                                                               ? groupByColumnStyle(row)
                                                                               : highlightedColumns?.includes(column)
                                                                                   ? highlightedColumnsColor[column] || highlightedColor
                                                                                   : undefined,
                                                               textAlign: alignCell(column),
                                                               width:
                                                                   columnStyles && columnStyles[index + 1]
                                                                       ? columnStyles[index + 1]
                                                                       : undefined,
                                                           }}>
                                                    {renderCell(column, index, row)}
                                                </TableCell>
                                            ))}
                                        {displayedColumns.includes("action") && (
                                            <TableMenuComponent
                                                row={row}
                                                handleDelete={props.handleDelete}
                                                goToDetail={() => goToDetail(row)}
                                                handleOpenDialogHistory={props.handleOpenDialogHistory}
                                                editWithDialog={props.editWithDialog}
                                                showActions={showActions}
                                                handleDuplicate={handleDuplicate}
                                                menuLayout={menuLayout}
                                                downloadFn={() => downloadFn(row)}
                                                customMenuItems={customMenuItems}
                                                isNpiTemplate={isNpiTemplate}
                                            />
                                        )}
                                    </TableRow>
                                ))
                            ) : (
                                <TableRow>
                                    <TableCell
                                        colSpan={displayedColumns.length}
                                        sx={{
                                            textAlign: "left",
                                            fontSize: "14px",
                                            padding: "8px"
                                        }}
                                    >
                                        {translate.t("empty_listing")}
                                    </TableCell>
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>
                </TableContainer>
                <Divider/>
                <Box alignItems="center" display="flex" justifyContent="space-between" width="100%" paddingX="0.5rem">
                    {loading && <CircularProgress size="30px" />}
                    {props.page != undefined && <TablePagination
                        sx={{color: "#45485F", textAlign: "end", minHeight: "52px", maxHeight: "52px", width: "100%"}}
                        component="div"
                        rowsPerPageOptions={rowsPerPageOptions}
                        colSpan={12}
                        count={Number(props.count ?? 0)}
                        rowsPerPage={props.rowsPerPage}
                        page={props.page}
                        onPageChange={props.onPageChange}
                        onRowsPerPageChange={props.handleChangeRowsPerPage}
                        ActionsComponent={props.actionsComponent}
                        labelRowsPerPage={translate.t("rows_per_page")}
                        labelDisplayedRows={({from, to, count}) =>
                            showPaginated(from, to, count)
                        }
                    />}
                </Box>
            </Paper>
        </Box>
    );
};

export default TablePaginationComponent;
